// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function values_encode(v) {
  return Js_dict.fromArray([
              [
                "type",
                Decco.stringToJson(v._type)
              ],
              [
                "auto",
                Decco.optionToJson(Decco.intToJson, v.auto)
              ],
              [
                "manual",
                Decco.optionToJson(Decco.intToJson, v.manual)
              ],
              [
                "threshold",
                Decco.optionToJson(Decco.intToJson, v.threshold)
              ],
              [
                "ratio",
                Decco.optionToJson(Decco.floatToJson, v.ratio)
              ],
              [
                "radius_delta",
                Decco.optionToJson(Decco.intToJson, v.radius_delta)
              ]
            ]);
}

function validation_encode(v) {
  return Js_dict.fromArray([
              [
                "validation_type",
                Decco.stringToJson(v.validation_type)
              ],
              [
                "segment_names",
                Decco.listToJson(Decco.stringToJson, v.segment_names)
              ]
            ]);
}

function validations_encode(v) {
  return Js_dict.fromArray([[
                "validations",
                Decco.arrayToJson(validation_encode, v.validations)
              ]]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "geo_region_id",
                Decco.intToJson(v.geo_region_id)
              ],
              [
                "vehicle_id",
                Decco.intToJson(v.vehicle_id)
              ],
              [
                "zone_ids",
                Decco.arrayToJson(Decco.intToJson, v.zone_ids)
              ],
              [
                "cluster_ids",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(Decco.intToJson, param);
                      }), v.cluster_ids)
              ],
              [
                "name",
                Decco.stringToJson(v.campaign_name)
              ],
              [
                "effective_from",
                Decco.floatToJson(v.effective_from)
              ],
              [
                "effective_till",
                Decco.optionToJson(Decco.floatToJson, v.effective_till)
              ],
              [
                "type",
                Decco.stringToJson(v._type)
              ],
              [
                "sub_type",
                Decco.stringToJson(v.sub_type)
              ],
              [
                "values",
                values_encode(v.values)
              ],
              [
                "days_of_week",
                Decco.arrayToJson(Decco.stringToJson, v.days_of_week)
              ],
              [
                "day_start_hour",
                Decco.optionToJson(Decco.intToJson, v.day_start_hour)
              ],
              [
                "day_start_min",
                Decco.optionToJson(Decco.intToJson, v.day_start_min)
              ],
              [
                "day_end_hour",
                Decco.optionToJson(Decco.intToJson, v.day_end_hour)
              ],
              [
                "day_end_min",
                Decco.optionToJson(Decco.intToJson, v.day_end_min)
              ],
              [
                "validations",
                Decco.optionToJson(validations_encode, v.validations)
              ]
            ]);
}

export {
  values_encode ,
  validation_encode ,
  validations_encode ,
  t_encode ,
  
}
/* No side effect */
